import {
  CreateWorkplaceRequestCategoryParams,
  UpdateWorkplaceRequestCategoryParams,
  WorkplaceRequestCategoriesParams,
  WorkplaceRequestCategoriesResponse,
  WorkplaceRequestCategory
} from "../types/workplace-request-categories";
import { BaseSettingsEndpoints } from "./base";

const WORKPLACE_REQUEST_CATEGORIES_BASE_PATH = "/v1/tickets/categories";

export class WorkplaceRequestCategoriesClient extends BaseSettingsEndpoints {
  async getWorkplaceRequestCategories({
    cursor,
    limit
  }: WorkplaceRequestCategoriesParams = {}) {
    const params = new URLSearchParams();

    if (cursor) {
      params.set("cursor", cursor);
    }

    if (limit) {
      params.set("limit", limit.toString());
    }

    const queryString = params.toString();
    const url = `${WORKPLACE_REQUEST_CATEGORIES_BASE_PATH}${queryString ? `?${queryString}` : ""}`;

    return this.get<WorkplaceRequestCategoriesResponse>(url);
  }

  async createWorkplaceRequestCategory(
    data: CreateWorkplaceRequestCategoryParams
  ) {
    return this.post<
      CreateWorkplaceRequestCategoryParams,
      WorkplaceRequestCategory
    >(WORKPLACE_REQUEST_CATEGORIES_BASE_PATH, data);
  }

  async updateWorkplaceRequestCategory(
    categoryId: string,
    data: UpdateWorkplaceRequestCategoryParams
  ) {
    return this.update<
      UpdateWorkplaceRequestCategoryParams,
      WorkplaceRequestCategory
    >(`${WORKPLACE_REQUEST_CATEGORIES_BASE_PATH}/${categoryId}`, data);
  }

  async deleteWorkplaceRequestCategory(categoryId: string) {
    return this.delete(
      `${WORKPLACE_REQUEST_CATEGORIES_BASE_PATH}/${categoryId}`
    );
  }
}
